//noinspection JSFileReferences
import index from './story/index.js';

index.init();